import React from 'react'
import '../styles/HeaderStyle.css'

function LoginHeader() {
  return (
    <div id='headerDiv'>
      <a href='/' id='backButton'>Go Back</a>
      <h1 id='title'>Login</h1>
    </div>
  )
}

export default LoginHeader